import { axios } from "lib/axios"
import { createOrSignInFirebaseUser } from './createFirebaseUser';
import { sendVerificationEmailIfAllowed } from './sendVerificationEmail';
import { toApiError } from './login';

export const toVat = (vat) => `SE${vat}01`;

export const membershipIdForVat = (account, vat) =>
  account?.users?.find((user) => user?.Company?.VAT === toVat(vat))?.user_id ?? null;

export const register = async (data, newFirebaseUser = true) => {
  let userCredential;
  if (newFirebaseUser) {
    userCredential = await createOrSignInFirebaseUser(data.companyEmail, data.password);
  }

  try {
    const account = await registerRequest(data);
    if (userCredential && !userCredential.user.emailVerified) {
      await sendVerificationEmailIfAllowed();
    }
    return account;
  } catch (error) {
    throw toApiError(error);
  }
}

const registerRequest = async (data) => {
  return await axios.post("/auth/register", {
    user: {
      first_name: data.firstName,
      last_name: data.lastName,
      phone_number: data.phoneNumber,
    },
    company: {
      name: data.companyName,
      country: data.country,
      vat: toVat(data.vat),
    },
    'cf-turnstile-response': data.turnstileToken,
  });
}
